import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BodyBackgroundService {

  private setClass = "";

  setBackground(color: string): any {

    if (!this.document) return;

    if (this.setClass) {
      this.document.body.classList.remove(this.setClass);
      this.setClass = null;
    }

    if (color) {
      var className = 'bg-' + color;
      this.document.body.classList.add(className);
      this.setClass = className;
    }
  }

  constructor(
    @Inject(DOCUMENT) private document: Document) { }
}
